

































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import PersonAvatar from '@/components/global/avatar.vue'

/* Helpers */

/* Data types */
import { IPersonBase } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'AvatarGallery',

  components: {
    PersonAvatar,
  },

  props: {
    people: {
      type: Array as () => IPersonBase[],
      required: true,
    },
    /* If true, avatars will stack with only 1px separation between each other horizontally */
    stackTightly: {
      type: Boolean,
      default: false,
    },
    maxNumAvatars: {
      type: Number,
      default: 4,
    },
    maxNumAvatarsTooltip: {
      type: Number,
      default: 12,
    },
    size: {
      type: Number,
      default: 25,
    },
    suppressAvatarTooltip: {
      type: Boolean,
      default: false,
    },
    suppressRemainingPeopleTooltip: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasRemainingAvatars(): Boolean {
      return this.remainingAvatars > 0
    },
    avatarsToDisplay(): IPersonBase[] {
      const arrayToDisplay = [...this.people]
      return arrayToDisplay.splice(0, this.maxNumAvatars)
    },
    remainingAvatars(): Number {
      return this.people.length - this.maxNumAvatars
    },
    listRemainingAvatars(): IPersonBase[] {
      const arrayToDisplay = [...this.people].splice(this.maxNumAvatars)
      return arrayToDisplay.splice(0, this.maxNumAvatarsTooltip)
    },
    remainingTooltipAvatarsNote(): String {
      const remaining =
        [...this.people].splice(this.maxNumAvatars).length -
        this.maxNumAvatarsTooltip

      if (remaining > 0) {
        return '...and ' + remaining + ' more'
      }

      return ''
    },
  },
})
